// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as PlatformRouteRouteImport } from './routes/platform/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountIndexRouteImport } from './routes/account/index'
import { Route as ApiDocsRouteImport } from './routes/api.docs'
import { Route as AccountNewRouteImport } from './routes/account/new'
import { Route as PlatformIndexRouteImport } from './routes/platform/index'
import { Route as PlatformUsersRouteImport } from './routes/platform/users'
import { Route as PlatformModulesRouteImport } from './routes/platform/modules'
import { Route as PlatformAuditRouteImport } from './routes/platform/audit'
import { Route as AccountWorkspacesTenantIdRouteImport } from './routes/account/workspaces/$tenantId'
import { Route as PlatformTenantsIndexRouteImport } from './routes/platform/tenants/index'
import { Route as PlatformTenantsNewRouteImport } from './routes/platform/tenants/new'
import { Route as PlatformTenantsTenantIdRouteImport } from './routes/platform/tenants/$tenantId'

const SignUpRoute = SignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const AcceptInviteRoute = AcceptInviteRouteImport.update({
            id: '/accept-invite',path: '/accept-invite',getParentRoute: () => rootRouteImport
          })
const PlatformRouteRoute = PlatformRouteRouteImport.update({
            id: '/platform',path: '/platform',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AccountIndexRoute = AccountIndexRouteImport.update({
            id: '/account/',path: '/account/',getParentRoute: () => rootRouteImport
          })
const ApiDocsRoute = ApiDocsRouteImport.update({
            id: '/api/docs',path: '/api/docs',getParentRoute: () => rootRouteImport
          })
const AccountNewRoute = AccountNewRouteImport.update({
            id: '/account/new',path: '/account/new',getParentRoute: () => rootRouteImport
          })
const PlatformIndexRoute = PlatformIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PlatformRouteRoute
          })
const PlatformUsersRoute = PlatformUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => PlatformRouteRoute
          })
const PlatformModulesRoute = PlatformModulesRouteImport.update({
            id: '/modules',path: '/modules',getParentRoute: () => PlatformRouteRoute
          })
const PlatformAuditRoute = PlatformAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => PlatformRouteRoute
          })
const AccountWorkspacesTenantIdRoute = AccountWorkspacesTenantIdRouteImport.update({
            id: '/account/workspaces/$tenantId',path: '/account/workspaces/$tenantId',getParentRoute: () => rootRouteImport
          })
const PlatformTenantsIndexRoute = PlatformTenantsIndexRouteImport.update({
            id: '/tenants/',path: '/tenants/',getParentRoute: () => PlatformRouteRoute
          })
const PlatformTenantsNewRoute = PlatformTenantsNewRouteImport.update({
            id: '/tenants/new',path: '/tenants/new',getParentRoute: () => PlatformRouteRoute
          })
const PlatformTenantsTenantIdRoute = PlatformTenantsTenantIdRouteImport.update({
            id: '/tenants/$tenantId',path: '/tenants/$tenantId',getParentRoute: () => PlatformRouteRoute
          })





const PlatformRouteRouteChildren = {
  PlatformAuditRoute: PlatformAuditRoute,PlatformModulesRoute: PlatformModulesRoute,PlatformUsersRoute: PlatformUsersRoute,PlatformIndexRoute: PlatformIndexRoute,PlatformTenantsTenantIdRoute: PlatformTenantsTenantIdRoute,PlatformTenantsNewRoute: PlatformTenantsNewRoute,PlatformTenantsIndexRoute: PlatformTenantsIndexRoute
}

const PlatformRouteRouteWithChildren = PlatformRouteRoute._addFileChildren(PlatformRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,PlatformRouteRoute: PlatformRouteRouteWithChildren,AcceptInviteRoute: AcceptInviteRoute,ForgotPasswordRoute: ForgotPasswordRoute,PricingRoute: PricingRoute,ResetPasswordRoute: ResetPasswordRoute,SignInRoute: SignInRoute,SignUpRoute: SignUpRoute,AccountNewRoute: AccountNewRoute,ApiDocsRoute: ApiDocsRoute,AccountIndexRoute: AccountIndexRoute,AccountWorkspacesTenantIdRoute: AccountWorkspacesTenantIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)